import { Component, input } from "@angular/core";
import { PortfolioObjectShort } from "src/app/shared/contract/Portfolio/PortfolioObjectOverview";
import { TranslocoModule } from "@jsverse/transloco";
import { MatIconModule } from "@angular/material/icon";
import { FormsModule } from "@angular/forms";
import { TranslocoDecimalPipe } from "@jsverse/transloco-locale";
import { ObjectTypeFromSubtypePipe } from "src/app/shared/pipes/object-type-from-subtype.pipe";

@Component({
  selector: "app-portfolio-popup-info",
  imports: [TranslocoModule, MatIconModule, FormsModule, TranslocoDecimalPipe, ObjectTypeFromSubtypePipe],
  templateUrl: "./portfolio-popup-info.component.html",
  styleUrl: "./portfolio-popup-info.component.scss"
})
export class PortfolioPopupInfoComponent {
  portfolioObject = input<PortfolioObjectShort>(null);
}
